import { InvoiceModal } from "components/Modals"
import PaginationComponent from "components/Pagination"
import { useState } from "react"
import { AiOutlineFilePdf } from "react-icons/ai"
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table"
import { Button } from "reactstrap"
import "./styles.scss"

function TableComponent() {
  const data = [
    {
      date: "4/24/23",
      description: "REGULAR BILL",
      limit: "for 3/1/23 - 3/31/23",
      kw: "0000",
      kwh: "0000",
      download: "Download Invoice",
    },
    {
      date: "4/24/23",
      description: "REGULAR BILL",
      limit: "for 3/1/23 - 3/31/23",
      kw: "0000",
      kwh: "0000",
      download: "Download Invoice",
    },
    {
      date: "4/24/23",
      description: "REGULAR BILL",
      limit: "for 3/1/23 - 3/31/23",
      kw: "0000",
      kwh: "0000",
      download: "Download Invoice",
    },
    {
      date: "4/24/23",
      description: "REGULAR BILL",
      limit: "for 3/1/23 - 3/31/23",
      kw: "0000",
      kwh: "0000",
      download: "Download Invoice",
    },
  ]
  const [invoiceModal, setInvoiceModal] = useState(false)
  const toggleInvoiceModal = () => setInvoiceModal(!invoiceModal)
  const [modalData, setModalData] = useState({})

  return (
    <div>
      <Table
        id="tech-companies-1"
        className="table table-stripe billing-table text-center"
      >
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Description</Th>
            <Th>KW</Th>
            <Th>KWH</Th>
            <Th style={{ width: "20%" }}>Download</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.length &&
            data.map((item, index) => (
              <Tr key={index++}>
                <Td>{item.date}</Td>
                <Td>
                  <span className="fw-bolder">{item.description} </span>
                  <span className="fw-light">{item.limit}</span>
                </Td>
                <Td>{item.kw}</Td>
                <Td>{item.kwh}</Td>
                <Td>
                  <Button
                    color="primary"
                    className="rounded-5 ps-3"
                    onClick={() => {
                      toggleInvoiceModal()
                      setModalData(item)
                    }}
                  >
                    <AiOutlineFilePdf /> {item.download}
                  </Button>
                </Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
      <div className="mt-lg-5 mt-md-3 mt-1">
        <PaginationComponent />
      </div>
      <InvoiceModal
        modal={invoiceModal}
        toggle={toggleInvoiceModal}
        invoiceData={modalData}
      />
    </div>
  )
}

export default TableComponent
